export default __webpack_public_path__ + "static/media/eww-logo.92b5a74d.png";